import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

// inject admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rb100_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("rb100_admin_token");
      if (window.location.pathname.startsWith("/admin") &&
          !window.location.pathname.endsWith("/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

// Track a page visit (best-effort, never blocks UI)
let _visitTracked = false;
export const trackVisit = () => {
  if (_visitTracked) return;
  _visitTracked = true;
  api.post("/track-visit", {
    path: window.location.pathname,
    referrer: document.referrer || null,
  }).catch(() => {});
};

export const RB100_LOGO = "/rb100-logo.jpg";

// Transparent PNG version (white letters + red 100) — for dark/photo backgrounds
export const RB100_LOGO_PNG = "/rb100-logo.png";

export const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_rb100-classic-cars/artifacts/m6wjr2ae_Gemini_Generated_Image_c7w13uc7w13uc7w1.png";

// Latest gathering — Hawa Park (April 29 - May 1, 2026)
export const GALLERY_IMGS = [
  "/gathering-park/photo-1.jpeg",
  "/gathering-park/photo-2.jpeg",
  "/gathering-park/photo-3.jpeg",
  "/gathering-park/photo-4.jpeg",
];

// Older photos — Madinah Sports Stadium gathering
export const STADIUM_GALLERY = [
  "/gathering-stadium/photo-1.jpeg",
  "/gathering-stadium/photo-2.jpeg",
  "/gathering-stadium/photo-3.jpeg",
  "/gathering-stadium/photo-4.jpeg",
  "/gathering-stadium/photo-5.jpeg",
  "/gathering-stadium/photo-6.jpeg",
];

export const ABOUT_IMG = "/gathering/photo-10.jpeg";

// Government sponsor (الراعي الحكومي الرسمي)
export const GOV_SPONSOR = {
  name: "وزارة الرياضة",
  nameEn: "Ministry of Sport",
  logo: "https://customer-assets.emergentagent.com/job_rb100-classic-cars/artifacts/r5as3l61_image.png",
  url: null,
};

// Golden sponsors (الرعاة الذهبيين)
export const GOLD_SPONSORS = [
  {
    name: "اطلب قطعك",
    nameEn: "Order Your Parts",
    logo: "https://customer-assets.emergentagent.com/job_rb100-classic-cars/artifacts/dlawff2u_%D8%A8%D8%A7%D9%84%D8%B9%D8%B1%D8%B6.png",
    url: "https://orderurparts.com.sa/",
    urlLabel: "زيارة الموقع",
  },
  {
    name: "مركز 6 أيام",
    nameEn: "6 Days Garage",
    logo: "https://customer-assets.emergentagent.com/job_rb100-classic-cars/artifacts/iam9wj9u_6days.jpg",
    url: "https://www.google.com/maps/place/%D9%85%D8%B1%D9%83%D8%B2+%D8%B3%D8%AA%D8%A9+%D8%A7%D9%8A%D8%A7%D9%85+(2)+%D9%84%D8%B5%D9%8A%D8%A7%D9%86%D8%A9+%D8%A7%D9%84%D8%B3%D9%8A%D8%A7%D8%B1%D8%A7%D8%AA%E2%80%AD/@24.3846907,39.4614151,990m/data=!3m2!1e3!4b1!4m6!3m5!1s0x15bdcf00472f0831:0xe0121d54ea92e468!8m2!3d24.3846859!4d39.466286",
    urlLabel: "الموقع على الخريطة",
  },
  {
    name: "مركز نورين",
    nameEn: "Noreen",
    logo: "https://customer-assets.emergentagent.com/job_rb100-classic-cars/artifacts/wlg68a0o_Noreen-Logo-Final%202.png",
    url: "https://maps.app.goo.gl/qmCfKUb4Ek69uzUbA",
    urlLabel: "الموقع على الخريطة",
  },
];

export const VENUE = {
  name: "مركز هوا الترفيهي",
  nameEn: "Hawa Entertainment Center",
  mapUrl: "https://maps.app.goo.gl/adoVptkR4ReaAn4E6",
};
